export default __webpack_public_path__ + "static/media/Projects.77c49512.svg";